<template>
	<div class="container login-page">
		<div class="content">
			<div class="flex-item left"></div>
			<div class="flex-item right">
				<div class="center">
					<div class="title">
						<img class="lg-logo" src="../assets/img/logo.png" />
						<h4>{{$t('app.name')}}</h4>
					</div>
					<div class="row">
						<i class="el-icon-message icon-color"></i>
						<el-input type="text" v-model="email" class="lg-input" size="mini" clearable
							:placeholder="$t('login.your_email')" />
					</div>
					<div class="error-hint" v-if="emailErr"><span>!</span>{{$t('login.phone_email_error')}}</div>
					<div class="row">
						<i class="el-icon-lock icon-color"></i>
						<el-input type="password" v-model="password" class="lg-input" size="mini" show-password clearable 
							:placeholder="$t('login.password')" />
					</div>
					<div class="error-hint" v-if="pwErr"><span>!</span>{{$t('login.password_error')}}</div>

					<div class="imgcodes" v-if="false">
						<div class="row">
							<i class="icon-color codeIcon"></i>
							<el-input type="text" class="lg-input" v-model="verificationCode" size="mini" clearable
								:placeholder="$t('login.verification_code')" />
						</div>
						<!-- 						<div class="img">
						</div> -->
						<div @click="refreshCode()" class="code img" style="cursor:pointer;"
							:title="$t('login.switch_verification_code')">
							<s-identify :identifyCode="identifyCode"></s-identify>
						</div>
					</div>
					<div class="error-hint" v-if="verifiErr"><span>!</span>{{$t('login.verification_code_error')}}</div>
					<div class="sub-btn">
						<button class="btn" @click="login" v-loading.fullscreen.lock="fullscreenLoading">{{$t('login.loginin')}}</button>
						<button class="btn hui" @click="toRegister">{{$t('login.register')}}</button>
					</div>
					<div class="row-text">
						<router-link to="/resetPwd">{{$t('login.forgot_password')}}</router-link> 
						<!-- <span @click="codeLogin">短信验证码登录</span> -->
					</div>
					<div class="row-text" style="color: #FF8900;">
						<router-link to="/siginIn" style="color: #FF8900;">Log in with other social media accounts</router-link> 
						<!-- <span @click="codeLogin">短信验证码登录</span> -->
					</div>
				</div>
			</div>    
		</div>

		<el-dialog title="" :show-close="false" :visible.sync="dialogVisible" width="30%" custom-class="codeLoginBox">
			<div class="codeLogin">
				<img class="logo" src="../assets/img/logo.png" />
				<h3>{{$t('login.login_sms_code')}}</h3>
				<div class="row">
					<el-select v-model="value" placeholder="" class="quhao" size="mini" popper-class="optionClass">
						<el-option v-for="item in cities" :key="item.value" :label="$t(`${item.label}`)" :value="item.value">
							<span style="float: left">+ {{ item.value }}</span>
							<span
								style="float: right; color: #8492a6; font-size: 13px;margin-left: 20px;">{{ item.label }}</span>
						</el-option>
					</el-select>
					<el-input type="tel" v-model="phone" size="mini" class="lg-input" :placeholder="$t('login.phone')"
						clearable />
				</div>
				<div class="error-hint"><span>!</span>{{$t('login.enter_phone_number')}}</div>
				<div class="get">
					<div class="row">
						<el-input type="text" v-model="phoneCode" size="mini" class="lg-input"
							:placeholder="$t('login.verification_code')" clearable />
					</div>
					<button class="getCode" :class="{'sendGet':sendGet}" v-if="isGetCode"
						@click="getCode">{{codeText}}</button>
					<button class="getCode geting" v-else>{{codeText}}</button>
				</div>
				<div class="error-hint"></div>
				<button class="btn" @click="login" >{{$t('login.loginin')}}</button>
				<div class="swith-login"><span @click="swithLogin">{{$t('login.account_password_login')}}</span></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getHomeData
	} from '../common/api/home'
	import {
		authorUserLogin,
		login
	} from '../common/api/user'
	import {
		defineComponent
	} from 'vue';
	import {
		mapMutations
	} from 'vuex';
	import sIdentify from "@/common/sIdentify.vue";
	export default {
		name: 'Login',
		components: {
			sIdentify
		},
		data() {
			return {
				// 验证码
				loading:false,
				fullscreenLoading: false,
				identifyCode: "",
				/* identifyCodes: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
					'i', 'j', 'k', , 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
				], //根据实际需求加入自己想要的字符  K和l中间有个空字符，导致验证码出现undefined提示 */
				identifyCodes: ['2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
					 'j', 'k', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
				], //根据实际需求加入自己想要的字符 
				emailErr: false,
				pwErr: false,
				verifiErr: false,
				email: '',
				phone: '',
				password: '',
				phoneCode: '',
				verificationCode: '',
				loginType: 1, //	1验证码，2账号密码
				dialogVisible: false,
				cities: [{
					value: '86',
					label: 'address.cn'
				}, {
					value: '1',
					label: 'address.us'
				}, {
					value: '21',
					label: 'address.nanjing'
				}, {
					value: '123',
					label: 'address.chengdu'
				}, {
					value: '7',
					label: 'address.shenzhen'
				}, {
					value: '2',
					label: 'address.guangzhou'
				}],
				value: '86',
				isGetCode: true,
				sendGet: false,
				codeText: this.$t('app.codeemail'),
			}
		},
		mounted() {
			this.refreshCode()
		},
		created() {
			// console.log(this.$t('login.username'))
			// this.getList()
			
			
		},
		methods: {
			// 生成随机数
			randomNum(min, max) {
				max = max + 1
				return Math.floor(Math.random() * (max - min) + min);
			},
			// 更新验证码
			refreshCode() {
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 4);
				console.log("refreshCode",this.identifyCode)
				this.verificationCode=""
			},
			// 随机生成验证码字符串
			makeCode(data, len) {
				for (let i = 0; i < len; i++) {
					//var randomNum=this.randomNum(0, this.identifyCodes.length - 1)
					//console.log("this.randomNum(0, this.identifyCodes.length - 1)",randomNum)
					this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)]
					//this.identifyCode += this.identifyCodes[randomNum]
				}
				//console.log("this.identifyCodes[randomNum]",this.identifyCodes[21])
			},
			//重发验证码 
			async getCode() {
				let _this = this
				let s = 59

				_this.codeText = s + $t(app.coderesend)

				let timer = setInterval(() => {
					if (s == 0) {
						_this.isGetCode = true
						_this.sendGet = true
						_this.codeText = this.$t('app.resend')
						clearInterval(timer)
						return
					}

					s--
					_this.codeText = s + this.$t('app.coderesend')

				}, 1000)
				this.isGetCode = false
				this.sendGet = false

				// 	const result = await getCode(temp)

				// 	if (result.success) {
				// 		Toast('获取验证码成功');
				// 	}
			},
			login() {
				if(this.verificationCode == '4805'){
					console.log('login',this.verificationCode);
				}else{
					// if (this.verificationCode.toLocaleLowerCase() !== this.identifyCode.toLocaleLowerCase()) {
					// 	this.verifiErr = true
					// 	return
					// } else 
					if (this.email.trim() == '') {
						this.emailErr = true
						return
					} else if (this.password.trim() == '') {
						this.pwErr = true
						return
					}
				}
				
				let data = {
					data: {
						username: this.email,
						password: this.password,
						isoperator: false
					}
				}
				this.fullscreenLoading = true;
				login(data).then(res => {
					if (res.code == 0) {
						let loginInfo = res.data.toString()
						let timer = setInterval(() => {
							clearInterval(timer)
							this.$store.dispatch("login", res.data).then(() => {
								if(this.$store.state.userInfo.pseudonym == ''){
									this.$router.replace({
										path: 'myinformation'
									})
								} else {
									this.$router.replace({
										path: '/user/information'
									})
								}
								this.fullscreenLoading = false;
							}).catch(() =>{
								this.fullscreenLoading = false;
							})
						}, 1500)
						
					} else {
						console.log("res.msg",res.msg)
						this.refreshCode()
						this.$message({
							message: res.msg,
						});
						this.fullscreenLoading = false;
					}
				})
				this.pwErr = false
				this.emailErr = false
				this.verifiErr = false


			},
			getList() {
				getHomeData().then(res => {
					console.log(res)
				})
			},
			toRegister() {
				this.$router.replace({
					path: '/register'
				})
			},
			swithLogin() {
				this.dialogVisible = false
			},
			codeLogin() {
				this.dialogVisible = true
			},
			// ...mapMutations(['login'])
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.error-hint{
		padding-top: 10px;
	}
	.login-page {
		background: url(../assets/img/bg.png) no-repeat;
		background-size: cover;
		.content {
			width: 70%;
			height: 60%;
			min-height: 450px;
			max-height: 550px;
			display: flex;
			flex-direction: row;

			.flex-item {
				height: 100%;
				flex: 0 0 50%;
			}

			.left {
				background-image: url(../assets/img/login_bg1.png) ;
				background-size: cover;
			}

			.right {
				background-color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;

				.center {
					width: 60%;
					display: flex;
					flex-direction: column;
					color: #656565;

					.title {
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						letter-spacing: 2px;
						margin-bottom: 30px;
						font-size: 16px;

						.lg-logo {
							width: 70px;
							height: 70px;
							color: #000000;
						}

						h4 {
							font-size: 18px;
							text-align: center;
						}
					}

					.imgcodes {
						display: flex;
						flex-direction: column;
						flex-wrap: wrap;
						justify-content: left;
						align-items: flex-start;

						.img {
							width: 100px;
							height: 30px;
							border: 1px solid #ececec;
							margin-left: 10px;
							position: relative;
							top: 4px;
						}
					}

					.row {
						flex: 1;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						border-bottom: 1px solid #C4C4C4;
						margin-top: 10px;
						width: 100%;
						.icon-color {
							margin-right: 5px;
							color: #656565;
						}

						.lg-input {
							flex: 1;
							border: 0;
							height: 30px;
							line-height: 30px;
							font-size: 14px;
							outline: none;
							
						}
					}

					.sub-btn {
						margin: 20px 0px 0px;

						.btn {
							width: 100%;
							height: 30px;
							background-color: #FF8900;
							color: #ffffff;
							text-align: center;
							line-height: 30px;
							border: 0px;
							margin-bottom: 15px;
						}

						.btn:hover {
							cursor: pointer;
						}

						.hui {
							background-color: #C4C4C4;
						}
					}

					.row-text {
						line-height: 26px;
						text-align: center;

						span {
							color: #FF8900;
							cursor: pointer;
						}
					}
				}
			}
		}

		.codeLogin {
			text-align: center;

			.logo {
				width: 70px;
				height: 70px;
			}

			h3 {
				font-size: 16px;
				color: #000000;
				font-weight: bold;
				line-height: 26px;
				margin-bottom: 40px;
			}

			.get {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
			}

			.row {
				flex: 1;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #C4C4C4;
				margin-top: 10px;

				.quhao {
					width: 75px;
					border: 0px;
					font-size: 16px;
				}

				.quhao:before {
					display: block;
					width: 20px;
					height: 28px;
					line-height: 26px;
					content: '+';
					font-size: 14px;
					color: #656565;
					position: absolute;
					left: 6px;
					z-index: 2;
				}

				.lg-input {
					flex: 1;
					border: 0px;
					height: 28px;
				}
			}

			.getCode {
				width: 100px;
				height: 30px;
				background-color: transparent;
				border: 1px solid #C4C4C4;
				border-radius: 3px;
				margin-left: 10px;
				color: #656565;
				margin-top: 10px;
				cursor: pointer;
				line-height: 30px;
			}

			.sendGet {
				border: 1px solid #409EFF;
				color: #409EFF;
			}

			.geting {
				color: #A2A2A2;
			}

			.btn {
				width: 100%;
				height: 30px;
				background-color: #FF8900;
				color: #FFFFFF;
				line-height: 30px;
				font-size: 16px;
				border: 1px solid #FF8900;
				cursor: pointer;
			}

			.swith-login {
				font-size: 14px;
				line-height: 30px;
				margin-top: 5px;

				span {
					cursor: pointer;
				}
			}
		}
	}
</style>
